// This file is auto-generated by update-blog-posts.js
// Contains metadata for blog posts, content is loaded separately.

export interface BlogMetadata {
  id: string;
  title: string;
  excerpt: string;
  contentPath: string; // Path to the content file relative to src
  image: string;
  category: string;
  tags: string[];
  page: string;
  date: string;
  readTime: string;
  author: string;
}

export const blogMetadataList: BlogMetadata[] = [
  {
    id: 'brachycephalic-breeds-special-dietary-consideratio - Copy',
    title: `Brachycephalic Breeds: Special Dietary Considerations for Flat-Faced Dogs`, // Use template literals for titles
    excerpt: `Flat-faced or brachycephalic dog breeds, such as Bulldogs, Pugs, and French Bulldogs, are beloved companions known for their charming, expressive face...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/brachycephalic-breeds-special-dietary-consideratio - Copy.html', // Store the relative path
    image: '/images/blog/brachycephalic-breeds-special-dietary-consideratio - Copy.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'breeds', 'dog food'],
    page: 'blog-brachycephalic-breeds-special-dietary-consideratio - Copy',
    date: 'January 21, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'brachycephalic-breeds-special-dietary-consideratio',
    title: `Brachycephalic Breeds: Special Dietary Considerations for Flat-Faced Dogs`, // Use template literals for titles
    excerpt: `Brachycephalic dogs, or flat-faced breeds such as Bulldogs, Pugs, French Bulldogs, and Shih Tzus, have unique nutritional needs due to their distinct ...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/brachycephalic-breeds-special-dietary-consideratio.html', // Store the relative path
    image: '/images/blog/brachycephalic-breeds-special-dietary-consideratio.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'supplements', 'breeds'],
    page: 'blog-brachycephalic-breeds-special-dietary-consideratio',
    date: 'February 13, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'breed-specific-health-issues-and-how-diet-can-help',
    title: `Breed-Specific Health Issues and How Diet Can Help`, // Use template literals for titles
    excerpt: `Ensuring our furry companions live healthy, vibrant lives involves understanding breed-specific health issues. A crucial yet sometimes overlooked fact...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/breed-specific-health-issues-and-how-diet-can-help.html', // Store the relative path
    image: '/images/blog/breed-specific-health-issues-and-how-diet-can-help.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'breeds', 'dog food'],
    page: 'blog-breed-specific-health-issues-and-how-diet-can-help',
    date: 'January 31, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'carbohydrates-in-pet-food-friend-or-foe',
    title: `Carbohydrates in Pet Food: Friend or Foe?`, // Use template literals for titles
    excerpt: `Pet owners often find themselves puzzled by the ingredients listed on their pet's food packaging. One of the most controversial topics in pet nutritio...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/carbohydrates-in-pet-food-friend-or-foe.html', // Store the relative path
    image: '/images/blog/carbohydrates-in-pet-food-friend-or-foe.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'protein', 'breeds'],
    page: 'blog-carbohydrates-in-pet-food-friend-or-foe',
    date: 'March 6, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'controversial-ingredients-in-pet-food-separating-f',
    title: `Controversial Ingredients in Pet Food: Separating Fact from Fiction`, // Use template literals for titles
    excerpt: `Pet food nutrition is a passionate subject among pet parents, veterinarians, and nutritionists alike. With countless brands and types of pet food avai...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/controversial-ingredients-in-pet-food-separating-f.html', // Store the relative path
    image: '/images/blog/controversial-ingredients-in-pet-food-separating-f.jpg',
    category: 'Pet Food Ingredients',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-controversial-ingredients-in-pet-food-separating-f',
    date: 'February 25, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'decoding-pet-food-labels-what-those-ingredients-re',
    title: `Decoding Pet Food Labels: What Those Ingredients Really Mean`, // Use template literals for titles
    excerpt: `Choosing the right pet food can seem overwhelming, especially when you're faced with labels filled with long and tricky ingredient names. As pet paren...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/decoding-pet-food-labels-what-those-ingredients-re.html', // Store the relative path
    image: '/images/blog/decoding-pet-food-labels-what-those-ingredients-re.jpg',
    category: 'Pet Food Ingredients',
    tags: ['nutrition', 'diet', 'health', 'protein', 'dog food'],
    page: 'blog-decoding-pet-food-labels-what-those-ingredients-re',
    date: 'April 2, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'digestive-health-choosing-the-right-food-for-sensi',
    title: `Digestive Health: Choosing the Right Food for Sensitive Stomachs`, // Use template literals for titles
    excerpt: `As pet owners, we strive to ensure our furry companions remain healthy and happy. One common issue many pets face is digestive sensitivity, often mark...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/digestive-health-choosing-the-right-food-for-sensi.html', // Store the relative path
    image: '/images/blog/digestive-health-choosing-the-right-food-for-sensi.jpg',
    category: 'Health',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-digestive-health-choosing-the-right-food-for-sensi',
    date: 'February 23, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'essential-fatty-acids-why-your-pet-needs-omega-3-a',
    title: `Essential Fatty Acids: Why Your Pet Needs Omega-3 and Omega-6`, // Use template literals for titles
    excerpt: `Essential fatty acids (EFAs) are crucial nutrients that pets must obtain from their diets because their bodies cannot synthesize them naturally. Omega...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/essential-fatty-acids-why-your-pet-needs-omega-3-a.html', // Store the relative path
    image: '/images/blog/essential-fatty-acids-why-your-pet-needs-omega-3-a.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'supplements', 'dog food'],
    page: 'blog-essential-fatty-acids-why-your-pet-needs-omega-3-a',
    date: 'March 28, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'fish-oil-benefits-for-dogs-improving-skin-coat-and',
    title: `Fish Oil Benefits for Dogs: Improving Skin, Coat, and Overall Health`, // Use template literals for titles
    excerpt: `Fish oil is increasingly recognized as a beneficial supplement for dogs, thanks to its rich content of omega-3 fatty acids. Regular supplementation ca...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/fish-oil-benefits-for-dogs-improving-skin-coat-and.html', // Store the relative path
    image: '/images/blog/fish-oil-benefits-for-dogs-improving-skin-coat-and.jpg',
    category: 'Health',
    tags: ['nutrition', 'diet', 'health', 'supplements', 'dog food'],
    page: 'blog-fish-oil-benefits-for-dogs-improving-skin-coat-and',
    date: 'March 4, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'grain-free-diets-benefits-and-considerations-for-y',
    title: `Grain-Free Diets: Benefits and Considerations for Your Pet`, // Use template literals for titles
    excerpt: `With the increasing popularity of specialty pet foods, pet owners often find themselves asking whether a grain-free diet might be the healthier choice...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/grain-free-diets-benefits-and-considerations-for-y.html', // Store the relative path
    image: '/images/blog/grain-free-diets-benefits-and-considerations-for-y.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'dog food'],
    page: 'blog-grain-free-diets-benefits-and-considerations-for-y',
    date: 'January 15, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'holiday-food-safety-protecting-your-pet-during-fes',
    title: `Holiday Food Safety: Protecting Your Pet During Festive Seasons`, // Use template literals for titles
    excerpt: `The holiday season brings joy, celebration, and plenty of festive foods. While humans eagerly dive into holiday treats, some traditional goodies pose ...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/holiday-food-safety-protecting-your-pet-during-fes.html', // Store the relative path
    image: '/images/blog/holiday-food-safety-protecting-your-pet-during-fes.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'dog food', 'cat food'],
    page: 'blog-holiday-food-safety-protecting-your-pet-during-fes',
    date: 'January 22, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'how-proper-nutrition-can-extend-your-pet-s-lifespa',
    title: `How Proper Nutrition Can Extend Your Pet's Lifespan`, // Use template literals for titles
    excerpt: `Your pet is more than just a companion; they’re family. Like any family member, their health and longevity are paramount. One of the most effective wa...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/how-proper-nutrition-can-extend-your-pet-s-lifespa.html', // Store the relative path
    image: '/images/blog/how-proper-nutrition-can-extend-your-pet-s-lifespa.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-how-proper-nutrition-can-extend-your-pet-s-lifespa',
    date: 'February 20, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'hypoallergenic-pet-foods-solutions-for-allergic-pe',
    title: `Hypoallergenic Pet Foods: Solutions for Allergic Pets`, // Use template literals for titles
    excerpt: `Just like humans, pets can also develop allergic reactions to certain foods. Food allergies in pets are often overlooked and misdiagnosed, yet they ca...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/hypoallergenic-pet-foods-solutions-for-allergic-pe.html', // Store the relative path
    image: '/images/blog/hypoallergenic-pet-foods-solutions-for-allergic-pe.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'protein', 'dog food'],
    page: 'blog-hypoallergenic-pet-foods-solutions-for-allergic-pe',
    date: 'March 13, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'joint-supplements-glucosamine-chondroitin-and-msm',
    title: `Joint Supplements: Glucosamine, Chondroitin, and MSM for Aging Pets`, // Use template literals for titles
    excerpt: `As our beloved pets age, maintaining joint health becomes increasingly crucial to ensuring their comfort and mobility. Supplements such as glucosamine...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/joint-supplements-glucosamine-chondroitin-and-msm.html', // Store the relative path
    image: '/images/blog/joint-supplements-glucosamine-chondroitin-and-msm.jpg',
    category: 'Supplements',
    tags: ['health', 'supplements', 'senior dogs', 'breeds', 'cat food'],
    page: 'blog-joint-supplements-glucosamine-chondroitin-and-msm',
    date: 'February 13, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'low-carb-diets-for-diabetic-pets-what-you-need-to',
    title: `Low-Carb Diets for Diabetic Pets: What You Need to Know`, // Use template literals for titles
    excerpt: `Managing diabetes in pets can be challenging for pet owners. One crucial aspect that often dictates the success of diabetes control in animals is thei...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/low-carb-diets-for-diabetic-pets-what-you-need-to.html', // Store the relative path
    image: '/images/blog/low-carb-diets-for-diabetic-pets-what-you-need-to.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'dog food'],
    page: 'blog-low-carb-diets-for-diabetic-pets-what-you-need-to',
    date: 'February 4, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'natural-supplements-for-pet-anxiety-and-stress-rel',
    title: `Natural Supplements for Pet Anxiety and Stress Relief`, // Use template literals for titles
    excerpt: `Anxiety and stress in pets are more common than you might think. Just like humans, animals experience discomfort from changes in their surroundings, s...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/natural-supplements-for-pet-anxiety-and-stress-rel.html', // Store the relative path
    image: '/images/blog/natural-supplements-for-pet-anxiety-and-stress-rel.jpg',
    category: 'Supplements',
    tags: ['health', 'supplements', 'cat food', 'ingredients'],
    page: 'blog-natural-supplements-for-pet-anxiety-and-stress-rel',
    date: 'January 30, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'novel-proteins-benefits-of-exotic-meat-sources-in',
    title: `Novel Proteins: Benefits of Exotic Meat Sources in Pet Food`, // Use template literals for titles
    excerpt: `As pet owners, we always strive to provide the best nutrition for our furry family members. With food allergies and sensitivities becoming increasingl...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/novel-proteins-benefits-of-exotic-meat-sources-in.html', // Store the relative path
    image: '/images/blog/novel-proteins-benefits-of-exotic-meat-sources-in.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'protein', 'dog food'],
    page: 'blog-novel-proteins-benefits-of-exotic-meat-sources-in',
    date: 'March 14, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'nutrition-during-pregnancy-supporting-mother-dogs',
    title: `Nutrition During Pregnancy: Supporting Mother Dogs and Their Puppies`, // Use template literals for titles
    excerpt: `Ensuring proper nutrition during pregnancy is vital for the health of your mother dog and her growing pups. Adequate nourishment supports fetal develo...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/nutrition-during-pregnancy-supporting-mother-dogs.html', // Store the relative path
    image: '/images/blog/nutrition-during-pregnancy-supporting-mother-dogs.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-nutrition-during-pregnancy-supporting-mother-dogs',
    date: 'March 11, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'nutrition-for-geriatric-pets-supporting-quality-of',
    title: `Nutrition for Geriatric Pets: Supporting Quality of Life in the Golden Years`, // Use template literals for titles
    excerpt: `Just as nutritional needs evolve for humans as they age, our pets require specialized dietary attention during their geriatric years to maintain healt...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/nutrition-for-geriatric-pets-supporting-quality-of.html', // Store the relative path
    image: '/images/blog/nutrition-for-geriatric-pets-supporting-quality-of.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-nutrition-for-geriatric-pets-supporting-quality-of',
    date: 'January 25, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'nutrition-for-high-energy-working-dogs-fueling-per',
    title: `Nutrition for High-Energy Working Dogs: Fueling Performance`, // Use template literals for titles
    excerpt: `Working dogs—from police and military canines to search-and-rescue teams and agility champions—have exceptional nutritional needs. Ensuring these ener...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/nutrition-for-high-energy-working-dogs-fueling-per.html', // Store the relative path
    image: '/images/blog/nutrition-for-high-energy-working-dogs-fueling-per.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-nutrition-for-high-energy-working-dogs-fueling-per',
    date: 'February 27, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'nutrition-for-joint-health-foods-that-fight-arthri',
    title: `Nutrition for Joint Health: Foods That Fight Arthritis in Pets`, // Use template literals for titles
    excerpt: `Arthritis is a common health concern in pets, particularly as they age or for certain breeds predisposed to joint issues. Fortunately, proper nutritio...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/nutrition-for-joint-health-foods-that-fight-arthri.html', // Store the relative path
    image: '/images/blog/nutrition-for-joint-health-foods-that-fight-arthri.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-nutrition-for-joint-health-foods-that-fight-arthri',
    date: 'April 2, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'nutritional-needs-of-large-breed-dogs-from-puppyho',
    title: `Nutritional Needs of Large Breed Dogs: From Puppyhood to Adulthood`, // Use template literals for titles
    excerpt: `Large breed dogs have unique dietary requirements that differ significantly from smaller breeds. Proper nutrition during every stage of life—from play...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/nutritional-needs-of-large-breed-dogs-from-puppyho.html', // Store the relative path
    image: '/images/blog/nutritional-needs-of-large-breed-dogs-from-puppyho.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-nutritional-needs-of-large-breed-dogs-from-puppyho',
    date: 'April 2, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'preservatives-in-pet-food-the-good-the-bad-and-the',
    title: `Preservatives in Pet Food: The Good, the Bad, and the Ugly`, // Use template literals for titles
    excerpt: `Pet owners today are increasingly aware and sensitive about the quality and composition of the pet food they purchase. One critical yet often misunder...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/preservatives-in-pet-food-the-good-the-bad-and-the.html', // Store the relative path
    image: '/images/blog/preservatives-in-pet-food-the-good-the-bad-and-the.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'dog food', 'cat food'],
    page: 'blog-preservatives-in-pet-food-the-good-the-bad-and-the',
    date: 'February 17, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'probiotics-for-pets-enhancing-gut-health-and-immun',
    title: `Probiotics for Pets: Enhancing Gut Health and Immunity`, // Use template literals for titles
    excerpt: `Maintaining your pet’s health involves much more than regular exercise and balanced meals. An essential but often overlooked factor is gut health. Pro...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/probiotics-for-pets-enhancing-gut-health-and-immun.html', // Store the relative path
    image: '/images/blog/probiotics-for-pets-enhancing-gut-health-and-immun.jpg',
    category: 'Health',
    tags: ['nutrition', 'diet', 'health', 'dog food', 'cat food'],
    page: 'blog-probiotics-for-pets-enhancing-gut-health-and-immun',
    date: 'April 3, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'protein-sources-in-pet-food-a-comprehensive-compar',
    title: `Protein Sources in Pet Food: A Comprehensive Comparison`, // Use template literals for titles
    excerpt: `Choosing the right protein source is vital for the overall health and wellbeing of our pets. Protein is essential for muscle growth, tissue repair, im...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/protein-sources-in-pet-food-a-comprehensive-compar.html', // Store the relative path
    image: '/images/blog/protein-sources-in-pet-food-a-comprehensive-compar.jpg',
    category: 'Pet Care',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-protein-sources-in-pet-food-a-comprehensive-compar',
    date: 'February 21, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'puppy-nutrition-building-blocks-for-a-healthy-life',
    title: `Puppy Nutrition: Building Blocks for a Healthy Life`, // Use template literals for titles
    excerpt: `Nutritional care during puppyhood is fundamental to ensuring your pet lives a vibrant, healthy life. Much like humans, puppies require specific nutrie...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/puppy-nutrition-building-blocks-for-a-healthy-life.html', // Store the relative path
    image: '/images/blog/puppy-nutrition-building-blocks-for-a-healthy-life.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-puppy-nutrition-building-blocks-for-a-healthy-life',
    date: 'February 5, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'raw-food-diets-a-comprehensive-guide-for-dog-owner',
    title: `Raw Food Diets: A Comprehensive Guide for Dog Owners`, // Use template literals for titles
    excerpt: `As dog owners increasingly prioritize the health and longevity of their pets, diet emerges as a central topic of interest. Among various dietary optio...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/raw-food-diets-a-comprehensive-guide-for-dog-owner.html', // Store the relative path
    image: '/images/blog/raw-food-diets-a-comprehensive-guide-for-dog-owner.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'dog food', 'ingredients'],
    page: 'blog-raw-food-diets-a-comprehensive-guide-for-dog-owner',
    date: 'January 24, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'seasonal-allergies-how-diet-can-help-manage-sympto',
    title: `Seasonal Allergies: How Diet Can Help Manage Symptoms`, // Use template literals for titles
    excerpt: `Seasonal allergies aren't just a human problem; our furry friends also suffer from itchy skin, inflammation, and discomfort during allergy seasons. Wh...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/seasonal-allergies-how-diet-can-help-manage-sympto.html', // Store the relative path
    image: '/images/blog/seasonal-allergies-how-diet-can-help-manage-sympto.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-seasonal-allergies-how-diet-can-help-manage-sympto',
    date: 'January 4, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'seasonal-ingredients-incorporating-fresh-seasonal',
    title: `Seasonal Ingredients: Incorporating Fresh, Seasonal Foods into Your Pet's Diet`, // Use template literals for titles
    excerpt: `Just as seasonal eating provides numerous health benefits for humans, incorporating fresh, seasonal ingredients into your pet's diet can also boost th...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/seasonal-ingredients-incorporating-fresh-seasonal.html', // Store the relative path
    image: '/images/blog/seasonal-ingredients-incorporating-fresh-seasonal.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'dog food'],
    page: 'blog-seasonal-ingredients-incorporating-fresh-seasonal',
    date: 'January 19, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'senior-pet-nutrition-adapting-diet-as-your-pet-age',
    title: `Senior Pet Nutrition: Adapting Diet as Your Pet Ages`, // Use template literals for titles
    excerpt: `As our beloved pets age, their nutritional needs evolve significantly. Maintaining proper nutrition is one of the key factors for ensuring they remain...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/senior-pet-nutrition-adapting-diet-as-your-pet-age.html', // Store the relative path
    image: '/images/blog/senior-pet-nutrition-adapting-diet-as-your-pet-age.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-senior-pet-nutrition-adapting-diet-as-your-pet-age',
    date: 'January 14, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'small-breed-nutrition-meeting-the-unique-needs-of',
    title: `Small Breed Nutrition: Meeting the Unique Needs of Tiny Dogs`, // Use template literals for titles
    excerpt: `Small breed dogs, while compact in size, have distinct nutritional requirements that set them apart from larger breeds. Recognizing and catering to th...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/small-breed-nutrition-meeting-the-unique-needs-of.html', // Store the relative path
    image: '/images/blog/small-breed-nutrition-meeting-the-unique-needs-of.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-small-breed-nutrition-meeting-the-unique-needs-of',
    date: 'January 3, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'summer-nutrition-keeping-your-pet-hydrated-and-hea',
    title: `Summer Nutrition: Keeping Your Pet Hydrated and Healthy in Hot Weather`, // Use template literals for titles
    excerpt: `The summer months bring rising temperatures that can significantly impact your pet's health. Proper nutrition plays a critical role in helping your fu...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/summer-nutrition-keeping-your-pet-hydrated-and-hea.html', // Store the relative path
    image: '/images/blog/summer-nutrition-keeping-your-pet-hydrated-and-hea.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'puppies'],
    page: 'blog-summer-nutrition-keeping-your-pet-hydrated-and-hea',
    date: 'January 27, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'superfoods-for-pets-nutrient-dense-additions-to-yo',
    title: `Superfoods for Pets: Nutrient-Dense Additions to Your Pet's Diet`, // Use template literals for titles
    excerpt: `Ensuring your pet thrives requires more than just daily exercise and routine check-ups. Nutrition plays a pivotal role in your furry companion's overa...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/superfoods-for-pets-nutrient-dense-additions-to-yo.html', // Store the relative path
    image: '/images/blog/superfoods-for-pets-nutrient-dense-additions-to-yo.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-superfoods-for-pets-nutrient-dense-additions-to-yo',
    date: 'March 2, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'the-complete-guide-to-balanced-dog-nutrition-what',
    title: `Balanced Dog Nutrition: The 6 Essential Nutrients`, // Use template literals for titles
    excerpt: `Good nutrition is the cornerstone of your dog's health, longevity, and overall wellbeing. Proper nutrition involves understanding the essential nutrie...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/the-complete-guide-to-balanced-dog-nutrition-what.html', // Store the relative path
    image: '/images/blog/the-complete-guide-to-balanced-dog-nutrition-what.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'puppies'],
    page: 'blog-the-complete-guide-to-balanced-dog-nutrition-what',
    date: 'February 22, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'the-connection-between-diet-and-your-pet-s-coat-he',
    title: `The Connection Between Diet and Your Pet's Coat Health`, // Use template literals for titles
    excerpt: `A shiny, silky coat often symbolizes excellent pet health and reflects the quality of your pet's diet. Nutrition directly affects skin and coat condit...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/the-connection-between-diet-and-your-pet-s-coat-he.html', // Store the relative path
    image: '/images/blog/the-connection-between-diet-and-your-pet-s-coat-he.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-the-connection-between-diet-and-your-pet-s-coat-he',
    date: 'February 25, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'the-impact-of-diet-on-your-pet-s-dental-health',
    title: `The Impact of Diet on Your Pet's Dental Health`, // Use template literals for titles
    excerpt: `Just like humans, our pets' diet significantly influences their overall dental health. Choosing the right diet can mean the difference between sparkli...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/the-impact-of-diet-on-your-pet-s-dental-health.html', // Store the relative path
    image: '/images/blog/the-impact-of-diet-on-your-pet-s-dental-health.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'dog food', 'cat food'],
    page: 'blog-the-impact-of-diet-on-your-pet-s-dental-health',
    date: 'March 31, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'transitioning-from-puppy-to-adult-food-when-and-ho',
    title: `Transitioning from Puppy to Adult Food: When and How to Switch`, // Use template literals for titles
    excerpt: `As our furry companions grow, their nutritional requirements change dramatically. Transitioning your puppy to adult food is an important milestone in ...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/transitioning-from-puppy-to-adult-food-when-and-ho.html', // Store the relative path
    image: '/images/blog/transitioning-from-puppy-to-adult-food-when-and-ho.jpg',
    category: 'Life Stages',
    tags: ['nutrition', 'diet', 'health', 'protein', 'puppies'],
    page: 'blog-transitioning-from-puppy-to-adult-food-when-and-ho',
    date: 'March 2, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'understanding-cat-nutrition-essential-nutrients-fo',
    title: `Understanding Cat Nutrition: Essential Nutrients for Feline Health`, // Use template literals for titles
    excerpt: `As pet parents, ensuring optimal health and happiness for our feline companions begins with proper nutrition. Cats have unique dietary requirements th...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/understanding-cat-nutrition-essential-nutrients-fo.html', // Store the relative path
    image: '/images/blog/understanding-cat-nutrition-essential-nutrients-fo.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'supplements'],
    page: 'blog-understanding-cat-nutrition-essential-nutrients-fo',
    date: 'February 5, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'vitamin-supplements-when-are-they-necessary-for-yo',
    title: `Vitamin Supplements: When Are They Necessary for Your Pet?`, // Use template literals for titles
    excerpt: `As loving pet owners, we often wonder whether we're providing our furry friends with everything they need for optimal health. Balanced nutrition gener...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/vitamin-supplements-when-are-they-necessary-for-yo.html', // Store the relative path
    image: '/images/blog/vitamin-supplements-when-are-they-necessary-for-yo.jpg',
    category: 'Supplements',
    tags: ['nutrition', 'diet', 'health', 'supplements', 'senior dogs'],
    page: 'blog-vitamin-supplements-when-are-they-necessary-for-yo',
    date: 'January 27, 2025',
    readTime: '5 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'weight-management-nutrition-plans-for-overweight-p',
    title: `Weight Management: Nutrition Plans for Overweight Pets`, // Use template literals for titles
    excerpt: `Managing your pet's weight is crucial for maintaining their overall health and longevity. Pet obesity can lead to serious health complications, includ...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/weight-management-nutrition-plans-for-overweight-p.html', // Store the relative path
    image: '/images/blog/weight-management-nutrition-plans-for-overweight-p.jpg',
    category: 'Nutrition',
    tags: ['nutrition', 'diet', 'health', 'protein', 'senior dogs'],
    page: 'blog-weight-management-nutrition-plans-for-overweight-p',
    date: 'January 19, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  },
  {
    id: 'winter-diet-adjustments-should-you-feed-more-in-co',
    title: `Winter Diet Adjustments: Should You Feed More in Cold Weather?`, // Use template literals for titles
    excerpt: `As winter approaches, pet owners often wonder whether colder weather translates to needing more calories for their pets. While it's true that many ani...`, // Use template literals for excerpts
    contentPath: 'src/data/blog-content/winter-diet-adjustments-should-you-feed-more-in-co.html', // Store the relative path
    image: '/images/blog/winter-diet-adjustments-should-you-feed-more-in-co.jpg',
    category: 'Diet',
    tags: ['nutrition', 'diet', 'health', 'protein', 'senior dogs'],
    page: 'blog-winter-diet-adjustments-should-you-feed-more-in-co',
    date: 'January 17, 2025',
    readTime: '4 min',
    author: `the Pawfectchow team` // Hardcode author here
  }
];